module.exports = __webpack_public_path__ + "static/img/cangchubg2.30c48f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cangchubg2.jpg
// module id = DCZr
// module chunks = 1